export const FIREBASE_EVENTS = {
  FUNNEL: "funnel",
  FUNNEL_START: "funnel_start",
  FUNNEL_SIGNUP: "funnel_sign_up",
  FUNNEL_SECOND_STEP: "funnel_second_step",
  FUNNEL_SECOND_STEP_START: "funnel_second_step_start",
};
